function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'home_merchant',
  cname: '店铺街',
  icon: 't-icon-zujian-dianpujie',
  configName: 'c_home_merchant',
  type: 0,
  // 0 基础组件 1 营销组件 2工具组件
  defaultName: 'homeMerchant',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('mobildConfig', ['defaultArray'])), mapGetters(['mediaDomain', 'mobileTheme'])), {}, {
    //最外层盒子的样式
    boxStyle: function boxStyle() {
      return [{
        'border-radius': this.configObj.bgStyle.val ? this.configObj.bgStyle.val + 'px' : '0'
      }, {
        background: "linear-gradient(".concat(this.configObj.bgColor.color[0].item, ", ").concat(this.configObj.bgColor.color[1].item, ")")
      }, {
        margin: this.configObj.mbConfig.val + 'px' + ' ' + this.configObj.lrConfig.val + 'px' + ' ' + 0
      }, {
        padding: this.configObj.upConfig.val + 'px' + ' ' + '10px' + ' ' + this.configObj.downConfig.val + 'px'
      }];
    },
    //图片样式
    contentStyle: function contentStyle() {
      return {
        'border-radius': this.configObj.contentStyle.val + 'px'
      };
    },
    //内容间距
    gridGap: function gridGap() {
      return {
        'grid-gap': this.configObj.contentConfig.val + 'px'
      };
    },
    //内容边距
    contentConfig: function contentConfig() {
      return [{
        'margin-right': this.configObj.contentConfig.val ? this.configObj.contentConfig.val + 'px' : '0'
      }];
    },
    //标题颜色
    titleColor: function titleColor() {
      return {
        color: this.configObj.titleColor.color[0].item
      };
    },
    //名称颜色
    nameColor: function nameColor() {
      return {
        color: this.configObj.nameColor.color[0].item
      };
    },
    //更多颜色
    moreColor: function moreColor() {
      return {
        color: this.configObj.moreColor.color[0].item
      };
    },
    //价格颜色
    priceColor: function priceColor() {
      return {
        color: this.themeStyle ? this.configObj.priceColor.color[0].item : this.themeColor
      };
    },
    //标签
    labelColor: function labelColor() {
      return [{
        backgroundColor: this.themeStyle ? this.configObj.labelColor.color[0].item : this.themeColor
      }, {
        color: this.configObj.labelFontColor.color[0].item
      }];
    },
    //店铺名称
    nameShow: function nameShow() {
      if (this.configObj.typeConfig.activeValue.indexOf(0) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    //店铺logo
    logoShow: function logoShow() {
      if (this.configObj.typeConfig.activeValue.indexOf(1) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    //店铺类型
    typeShow: function typeShow() {
      if (this.configObj.typeConfig.activeValue.indexOf(2) !== -1) {
        return true;
      } else {
        return false;
      }
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal, oVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    },
    listStyle: {
      handler: function handler(nVal, oVal) {
        if (this.themeStyle == 1) {
          this.configObj.priceColor.isShow = nVal;
        }
      },
      deep: true
    },
    themeStyle: {
      handler: function handler(nVal, oVal) {
        if (this.listStyle == 1) {
          this.configObj.priceColor.isShow = this.configObj.themeStyleConfig.tabVal;
          this.configObj.labelColor.isShow = this.configObj.themeStyleConfig.tabVal;
        } else {
          this.configObj.labelColor.isShow = this.configObj.themeStyleConfig.tabVal;
        }
      },
      deep: true
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        name: 'homeMerchant',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '店铺街'
        },
        logoConfig: {
          tabTitle: '图标设置',
          title: '上传图标',
          tips: '建议：124px*32px',
          isShow: 1,
          url: localStorage.getItem('mediaDomain') + '/crmebimage/presets/haodian.png'
        },
        titleConfig: {
          tabTitle: '标题设置',
          title: '标题内容',
          val: '正品大牌低价购',
          place: '请输入标题',
          isShow: 1,
          max: 10
        },
        linkConfig: {
          title: '更多链接',
          val: '/pages/merchant/merchant_street/index',
          place: '请选择链接',
          isShow: 1,
          max: 100
        },
        //数量
        numConfig: {
          tabTitle: '内容数量',
          title: '展示数量',
          val: 3,
          isShow: 1,
          max: 9
        },
        //显示内容
        typeConfig: {
          title: '展示信息',
          tabTitle: '显示内容',
          name: 'rowsNum',
          activeValue: [0, 1, 2],
          list: [{
            val: '店铺名称',
            icon: 'icon2hang'
          }, {
            val: '店铺logo',
            icon: 'icon3hang'
          }, {
            val: '店铺类型',
            icon: 'icon4hang'
          }]
        },
        tabConfig: {
          title: '展示样式',
          tabTitle: '布局设置',
          name: 'listStyle',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '样式一',
            icon: 'icon-dianpujie-yangshiyi'
          }, {
            val: '样式二',
            icon: 'icon-yangshisan'
          }]
        },
        listConfig: {
          tabTitle: '店铺数据',
          title: '店铺数据',
          tabVal: 0,
          isShow: 1,
          list: [{
            name: '默认规则'
          }, {
            name: '自定义'
          }]
        },
        activeValueMer: {
          title: '选择店铺',
          activeValue: [],
          list: [],
          isShow: 0,
          isMultiple: true,
          goodsList: []
        },
        //商户
        // 背景颜色
        bgColor: {
          tabTitle: '颜色设置',
          title: '背景颜色',
          color: [{
            item: 'rgba(255,255,255,0)'
          }, {
            item: 'rgba(255,255,255,0)'
          }],
          default: [{
            item: 'rgba(255,255,255,0)'
          }, {
            item: 'rgba(255,255,255,0)'
          }]
        },
        labelColor: {
          isShow: 0,
          title: '标签背景颜色',
          name: 'labelColor',
          color: [{
            item: '#e93323'
          }],
          default: [{
            item: '#e93323'
          }]
        },
        labelFontColor: {
          title: '标签文字颜色',
          name: 'labelColor',
          color: [{
            item: '#fff'
          }],
          default: [{
            item: '#fff'
          }]
        },
        titleColor: {
          title: '标题颜色',
          color: [{
            item: '#999999'
          }],
          default: [{
            item: '#999999'
          }]
        },
        moreColor: {
          title: '更多按钮颜色',
          color: [{
            item: '#282828'
          }],
          default: [{
            item: '#282828'
          }]
        },
        nameColor: {
          title: '店铺名称颜色',
          color: [{
            item: '#282828'
          }],
          default: [{
            item: '#282828'
          }]
        },
        //色调
        themeStyleConfig: {
          title: '色调',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '跟随主题风格'
          }, {
            val: '自定义'
          }]
        },
        priceColor: {
          isShow: 0,
          title: '价格颜色',
          color: [{
            item: '#e93323'
          }],
          default: [{
            item: '#e93323'
          }]
        },
        bgStyle: {
          tabTitle: '圆角设置',
          title: '背景圆角',
          name: 'bgStyle',
          val: 0,
          min: 0,
          max: 30
        },
        contentStyle: {
          title: '内容圆角',
          name: 'bgStyle',
          val: 7,
          min: 0,
          max: 30
        },
        // 上间距
        upConfig: {
          tabTitle: '边距设置',
          title: '上边距',
          val: 10,
          min: 0,
          max: 100
        },
        // 下间距
        downConfig: {
          title: '下边距',
          val: 10,
          min: 0
        },
        // 左右间距
        lrConfig: {
          title: '左右边距',
          val: 0,
          min: 0,
          max: 25
        },
        contentConfig: {
          title: '内容间距',
          val: 10,
          min: 0,
          max: 30
        },
        mbConfig: {
          title: '页面间距',
          val: 10,
          min: 0
        }
      },
      configObj: null,
      listStyle: 0,
      merList: [{
        name: '大王商城',
        streetBackImage: require('../../images/dianbj.png'),
        rectangleLogo: require('../../images/dafu.png'),
        coverImage: require('../../images/shangpin1.png'),
        proList: [{
          image: require('../../images/shangpin1.png'),
          name: '无线蓝牙耳机',
          price: '1299.00'
        }, {
          image: require('../../images/shangpin2.png'),
          name: '苹果新款平板',
          price: '1299.00'
        }, {
          image: require('../../images/shangpin3.png'),
          name: '蒸汽手持熨斗',
          price: '1299.00'
        }]
      }, {
        name: '大王商城',
        streetBackImage: require('../../images/dianbj.png'),
        rectangleLogo: require('../../images/dafu.png'),
        coverImage: require('../../images/shangpin2.png'),
        proList: [{
          image: require('../../images/shangpin1.png'),
          name: '无线蓝牙耳机',
          price: '1299.00'
        }, {
          image: require('../../images/shangpin2.png'),
          name: '苹果新款平板',
          price: '1299.00'
        }, {
          image: require('../../images/shangpin3.png'),
          name: '蒸汽手持熨斗',
          price: '1299.00'
        }]
      }, {
        name: '大王商城',
        streetBackImage: require('../../images/dianbj.png'),
        rectangleLogo: require('../../images/dafu.png'),
        coverImage: require('../../images/shangpin3.png'),
        proList: [{
          image: require('../../images/shangpin1.png'),
          name: '无线蓝牙耳机',
          price: '1299.00'
        }, {
          image: require('../../images/shangpin2.png'),
          name: '苹果新款平板',
          price: '1299.00'
        }, {
          image: require('../../images/shangpin3.png'),
          name: '蒸汽手持熨斗',
          price: '1299.00'
        }]
      }],
      src: '',
      themeStyle: 0,
      themeColor: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.num) {
        _this.pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
        _this.setConfig(_this.pageData);
      }
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      if (data) {
        this.configObj = data;
        this.listStyle = this.configObj.tabConfig.tabVal;
        this.src = this.configObj.logoConfig.url ? this.configObj.logoConfig.url : localStorage.getItem('mediaDomain') + '/crmebimage/presets/haodian.png';
        this.themeStyle = data.themeStyleConfig.tabVal;
        this.themeColor = this.$options.filters.filterTheme(this.mobileTheme - 1);
      }
    }
  }
};